import { checkIfExist } from "../../../services/GraphService";
import { IItemCheck } from "./IItemCheck";


export class SharepointSiteCheck implements IItemCheck {
    doesItemExist = async (itemId: string) => {
        const url = `sites/${itemId}`;
        return await checkIfExist(url, "id");
    };
}
